/**
 * Agrupa los turnos disponibles por profesional + clinica.
 * Cada grupo conserva la info del profesional/clinica, la cantidad de turnos
 * y el proximo turno (mas cercano en el tiempo).
 */
export const groupTurnosByProfessionalClinic = (turnos = []) => {
  const groups = {}

  turnos.forEach(t => {
    const key = `${t.idProfesional}-${t.clinica}`
    const dt = new Date(t.fechaTurnoDateTime)
    const latitud = t.latitud ?? t.Latitud
    const longitud = t.longitud ?? t.Longitud

    if (!groups[key]) {
      groups[key] = {
        idTurno: key,
        idProfesional: t.idProfesional,
        clinica: t.clinica,
        nombreProfesional: t.nombreProfesional,
        idEspecialidad: t.idEspecialidad,
        nombreEspecialidad: t.nombreEspecialidad,
        Latitud: latitud,
        Longitud: longitud,
        latitud,
        longitud,
        direccion: t.direccion,
        count: 1,
        nextTurnoDateTime: dt,
        fechaTurno: t.fechaTurno,
        durationMinutes: t.durationMinutes || 0,
        turnos: [t]
      }
    } else {
      const g = groups[key]
      g.count += 1
      g.turnos.push(t)

      if (dt < g.nextTurnoDateTime) {
        g.nextTurnoDateTime = dt
        g.fechaTurno = t.fechaTurno
      }

      if (!g.Latitud && latitud) {
        g.Latitud = latitud
        g.latitud = latitud
      }
      if (!g.Longitud && longitud) {
        g.Longitud = longitud
        g.longitud = longitud
      }
      if (!g.direccion && t.direccion) g.direccion = t.direccion
    }
  })

  return Object.values(groups)
}

export const filterMedicsByNext7Days = groupedMedics => {
  const now = new Date()
  const cutoff = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000)

  return groupedMedics.filter(
    g =>
      g.nextTurnoDateTime instanceof Date &&
      !Number.isNaN(g.nextTurnoDateTime.getTime()) &&
      g.nextTurnoDateTime >= now &&
      g.nextTurnoDateTime <= cutoff
  )
}

export const getNearestTurno = (turnos = []) => {
  const sorted = [...turnos].sort(
    (a, b) => new Date(a.fechaTurnoDateTime) - new Date(b.fechaTurnoDateTime)
  )

  return sorted[0] || null
}
